"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.integrations = exports.IntegrationIDs = void 0;
const yup = __importStar(require("yup"));
var IntegrationIDs;
(function (IntegrationIDs) {
    IntegrationIDs["BITGO"] = "BITGO";
    IntegrationIDs["CHAINALYSIS"] = "CHAINALYSIS";
    IntegrationIDs["CHAINALYSIS2"] = "CHAINALYSIS2";
    IntegrationIDs["COINFIRM"] = "COINFIRM";
    IntegrationIDs["COMPLYADVANTAGE"] = "COMPLYADVANTAGE";
    IntegrationIDs["CRYSTAL"] = "CRYSTAL";
    IntegrationIDs["ELLIPTIC"] = "ELLIPTIC";
    IntegrationIDs["LEXISNEXIS"] = "LEXISNEXIS";
    IntegrationIDs["MERKLESCIENCE"] = "MERKLESCIENCE";
    IntegrationIDs["REFINITIV"] = "REFINITIV";
    IntegrationIDs["TRM"] = "TRM";
    IntegrationIDs["TRMSANCTIONS"] = "TRMSANCTIONS";
})(IntegrationIDs = exports.IntegrationIDs || (exports.IntegrationIDs = {}));
exports.integrations = {
    [IntegrationIDs.CHAINALYSIS]: yup
        .object()
        .shape({
        apiKey: yup.string().required('Required value'),
    })
        .meta({
        apiKey: { label: 'API Key', type: 'text' },
    }),
    [IntegrationIDs.CHAINALYSIS2]: yup
        .object()
        .shape({
        apiKey: yup.string().required('Required value'),
    })
        .meta({
        apiKey: { label: 'API Key', type: 'text' },
    }),
    [IntegrationIDs.ELLIPTIC]: yup
        .object()
        .shape({
        accessKey: yup.string().required('Required value'),
        accessSecret: yup.string().required('Required value'),
    })
        .meta({
        accessKey: { label: 'Access Key', type: 'text' },
        accessSecret: { label: 'Access Secret', type: 'text' },
    }),
    [IntegrationIDs.REFINITIV]: yup
        .object()
        .shape({
        apiKey: yup.string().required('Required value'),
        apiSecret: yup.string().required('Required value'),
        groupId: yup.string().required('Required value'),
        useClientWatchList: yup.string().required('Required value'),
        customFields: yup.array().of(yup.object().shape({
            typeId: yup.string().required(),
            value: yup.string().required(),
        })),
    })
        .meta({
        apiKey: { label: 'API Key', type: 'text' },
        apiSecret: { label: 'API Secret', type: 'text' },
        groupId: { label: 'Group ID', type: 'text' },
        useClientWatchList: {
            type: 'dropdown',
            label: 'Use Client Watchlist',
            options: [
                { id: 'true', name: 'Yes' },
                { id: 'false', name: 'No' },
            ],
        },
        customFields: {
            type: 'array',
            label: 'Custom Fields',
            fields: ['typeId', 'value'],
        },
    }),
    [IntegrationIDs.BITGO]: yup
        .object()
        .shape({
        apiKey: yup.string().required('Required value'),
    })
        .meta({
        apiKey: { label: 'API Key', type: 'text' },
    }),
    [IntegrationIDs.TRM]: yup
        .object()
        .shape({
        apiKey: yup.string().required('Required value'),
    })
        .meta({
        apiKey: { label: 'API Key', type: 'text' },
    }),
    [IntegrationIDs.TRMSANCTIONS]: yup
        .object()
        .shape({
        apiKey: yup.string().required('Required value'),
    })
        .meta({
        apiKey: { label: 'API Key', type: 'text' },
    }),
    [IntegrationIDs.COMPLYADVANTAGE]: yup
        .object()
        .shape({
        accessApiKey: yup.string().required('Required value'),
    })
        .meta({
        accessApiKey: { label: 'Access API Key', type: 'text' },
    }),
    [IntegrationIDs.COINFIRM]: yup
        .object()
        .shape({
        apiKey: yup.string().required('Required value'),
    })
        .meta({
        apiKey: { label: 'API Key', type: 'text' },
    }),
    [IntegrationIDs.MERKLESCIENCE]: yup
        .object()
        .shape({
        apiKey: yup.string().required('Required value'),
    })
        .meta({
        apiKey: { label: 'API Key', type: 'text' },
    }),
    [IntegrationIDs.LEXISNEXIS]: yup
        .object()
        .shape({
        apiKey: yup.string().required('Required value'),
        environment: yup.string().required('Required value'),
        clientId: yup.string().required('Required value'),
        userId: yup.string().required('Required value'),
        userPassword: yup.string().required('Required value'),
        predefinedSearchName: yup.string().required('Required value'),
    })
        .meta({
        apiKey: { label: 'API Key', type: 'text' },
        environment: { label: 'Environment', type: 'text' },
        clientId: { label: 'Client ID', type: 'text' },
        userId: { label: 'User ID', type: 'text' },
        userPassword: { label: 'User Password', type: 'text' },
        predefinedSearchName: { label: 'Predefined Search Name', type: 'text' },
    }),
    [IntegrationIDs.CRYSTAL]: yup
        .object()
        .shape({
        apiKey: yup.string().required('Required value'),
    })
        .meta({
        apiKey: { label: 'API Key', type: 'text' },
    }),
};
